import React, { useContext } from "react";
import Text from "../../../../Diathrive/src/components/elements/Text";
import Button from "../../../../Diathrive/src/components/elements/Button";
import {
  BUTTON_TYPES,
  COLORS,
} from "../../../../Diathrive/src/utils/Constants";
import {
  COACHING_ONBOARDED,
  HTTP_METHODS,
} from "../../../../Diathrive/src/utils/URLConstants";
import { fetchApi } from "../../../../Diathrive/src/utils/ApiHelper";
import { loadingPauseContext } from "../../../../Diathrive/src/contexts/LoadingPauseContext";
import { accountStatusContext } from "../../../../Diathrive/src/contexts/AccountStatusContext";
import styles from "./styles";

const ONBOARDING_STEPS = [
  {
    headline: "Book an appointment",
    subtitle:
      "Set up a virtual meeting with an experienced health consultant who can guide you.",
  },
  {
    headline: "Gain Valuable Health Advice",
    subtitle:
      "Our commitment to leading you to a healthier life and managing your diabetes.",
  },
  {
    headline: "Long Term Guidance",
    subtitle:
      "Count on us for a long haul, build lasting relationships, and a plan for your health.",
  },
];

const CoachOnBoardingExperienceWeb = () => {
  const lpc = useContext(loadingPauseContext);
  const asc = useContext(accountStatusContext);

  const onPressMeetCoach = () => {
    lpc.setVisible(true);
    fetchApi(HTTP_METHODS.PUT, COACHING_ONBOARDED, {
      coachingOnboarded: true,
    })
      .then((response) => {
        if (response.data.status === "success") {
          asc.setOnboarded(true);
        }
        lpc.setVisible(false);
      })
      .catch(() => {
        lpc.setVisible(false);
      });
  };

  return (
    <div style={styles.onboardingContainer}>
      <Text variation="Headline4Bold" color={COLORS.blueDarkText}>
        Meet Your Health Advisor
      </Text>
      <Text
        variation="Text1Regular"
        color={COLORS.grey1}
        topMargin={8}
      >
        Health Advisors are Certified Diabetes Care and Education Specialists
        (CDCES) who can help you manage lifestyle changes, medication and more.
      </Text>
      {ONBOARDING_STEPS.map((step, index) => (
        <div key={index} style={styles.onboardingCard}>
          <Text variation="Subtitle2Bold" color={COLORS.blueDarkText}>
            {step.headline}
          </Text>
          <Text
            variation="Text1Regular"
            color={COLORS.grey1}
            topMargin={8}
          >
            {step.subtitle}
          </Text>
        </div>
      ))}
      <Button
        style={styles.onboardingButton}
        onPress={onPressMeetCoach}
        title={"Meet with a coach"}
        buttonType={BUTTON_TYPES.Filled}
        titleColor={COLORS.white}
      />
    </div>
  );
};

export default CoachOnBoardingExperienceWeb;
